module.exports = __webpack_public_path__ + "images/emoji/do_not_litter.cd84717680af8b75a036.png";